import axios from 'axios'
import apiList from './resource.js'
import newApi from './newApi'
export default {
  // 获取专家团
  investGetAdviser: function (data, successfn, errorfn) {
    return axios
      .post(newApi.getAjaxUrl('openapi', 'getAdviser'), data)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 获取AI智投直播列表
  getAiLiveList: function (data, successfn, errorfn) {
    return axios.post(apiList.invest.aiLiveList, data)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 获取专栏列表
  getColumnsList: function (data, successfn, errorfn) {
    return axios.post(apiList.invest.columnsList, data)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 获取专栏详情
  getColumnsDetail: function (data, successfn, errorfn) {
    return axios.post(apiList.invest.columnsDetail, data)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 专栏文章阅读添加
  addColumnIncReade: function (data, successfn, errorfn) {
    return axios.post(apiList.invest.columnIncReade, data)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 查看是否订阅专栏和专栏详情
  getColumnsSubscribeDeatil: function (data, successfn, errorfn) {
    return axios.post(newApi.getAjaxUrl('openapi', 'columnSubscribe'), data)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 查看是否订阅专栏
  getColumnSubscribeStatus: function (data, successfn, errorfn) {
    return axios.post(newApi.getAjaxUrl('openapi', 'columnSubscribeStatus'), data)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 订阅专栏---订阅
  columnSubscribeAdd: function (data, successfn, errorfn) {
    return axios.post(newApi.getAjaxUrl('openapi', 'columnSubscribeAdd'), data)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 订阅专栏---取消
  columnSubscribeClose: function (data, successfn, errorfn) {
    return axios.post(newApi.getAjaxUrl('openapi', 'columnSubscribeClose'), data)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 每日复盘---专栏视频查询
  getSpecialDynamic: function (data, successfn, errorfn) {
    return axios.get(newApi.getAjaxUrl('openapi', 'getSpecialDynamic'), data)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 文章详情页-最新解读
  getNewestSpecialDynamic: function (data, successfn, errorfn) {
    return axios.get(newApi.getAjaxUrl('openapi', 'getNewestSpecialDynamic'), data)
        .then(res => {
          successfn && successfn(res.data)
        })
        .catch(res => {
          errorfn && errorfn(res.data)
        })
  },
}



// WEBPACK FOOTER //
// ./src/fetch/invest.js